import React from 'react';


const Container = props => {
	const styles = {
		maxWidth: "1200px",
		width: "92%",
		margin: "0 auto"
	}

	if (props.flex)
		styles['display'] = 'flex'

	if (props.justifySpace)
		styles['justifyContent'] = 'space-between'

	return <div className="Container" style={ styles }>
		{ props.children }
	</div>
}

export default Container